import { yup } from '@medely/ui-kit';

export const w2InterestSchema = yup.object().shape({
  w2_interest: yup.number(),
});
